module.exports = __webpack_public_path__ + "img/alarm.c9947300.svg";